import { useDebounce } from '@hooks';
import { Input, Select } from 'antd';
import { useEffect, useState } from 'react';

import { TenantStatuses } from 'src/features/tenants/types/tenantList.types';

import { StatusViewByStatus } from '../../constants/StatusViewByStatus.const';
import { FilterContainer, InputsContainer } from './TenantListFilter.style';

interface FilterTenantListProps {
  onFilter: (filterKey: string, filterValue?: string) => void;
}

export const TenantListFilter = ({ onFilter }: FilterTenantListProps) => {
  const [statusFilter, setStatusFilter] = useState<string | undefined>(
    undefined
  );
  const [queryFilter, setQueryFilter] = useState<string | undefined>(undefined);

  const queryFilterDebounce = useDebounce(queryFilter ?? '', 900);

  useEffect(() => {
    if (queryFilter && queryFilter.length > 2) {
      onFilter('filter', queryFilter);
    }
  }, [queryFilterDebounce]);

  useEffect(() => {
    if (statusFilter) {
      onFilter('status', statusFilter);
    }
  }, [statusFilter]);

  return (
    <FilterContainer>
      <InputsContainer>
        <Input.Search
          key={`filter-coupon-code-search`}
          placeholder={'Buscar por tenant, cnpj, alias (Mínimo 3 letras)'}
          value={queryFilter}
          onChange={e => {
            setQueryFilter(e.target.value);
            if (e.target.value === '') onFilter('filter', undefined);
          }}
          style={{ flex: 1 }}
          allowClear
        />
        <Select
          placeholder={'Status'}
          data-testid={'asset-data-filter'}
          value={statusFilter}
          onChange={value => {
            setStatusFilter(value);
            if (!value) onFilter('status', undefined);
          }}
          style={{ minWidth: 250 }}
          allowClear
        >
          <Select.Option value={TenantStatuses.Active}>
            {StatusViewByStatus[TenantStatuses.Active].text}
          </Select.Option>
          <Select.Option value={TenantStatuses.Inactive}>
            {StatusViewByStatus[TenantStatuses.Inactive].text}
          </Select.Option>
        </Select>
      </InputsContainer>
    </FilterContainer>
  );
};
